// extracted by mini-css-extract-plugin
export default {"AuthModule":"AuthModule_AuthModule__1-QHH","AuthModule__button":"AuthModule_AuthModule__button__1aTaz"};